import { wrapper } from "../../redux";
import Detail from "/components/pages/articles/detail";
import Redis from "/lib/redis";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { sspWrapper } from "../../utils/errors/sspWrapper";
import { newsDetailLogic } from "../../pagesSrrLogic/news";

export default function NewsDetailPage({ scripts, host, news, isFarkop }) {
  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <Detail news={news} isFarkop={isFarkop} />
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ params, query, req, resolvedUrl }) => {
    return newsDetailLogic(
      Redis,
      store,
      query,
      req,
      resolvedUrl,
      params,
      "news",
      "Новости",
    );
  }),
);
